import { useState, useEffect } from "react";
import { Badge, Modal, Table, Button } from "react-bootstrap";
import { Clock } from "react-feather";

import authenticatedFetch from "./fetch"


const RenewalModal = ({show, onClose, renewalList}) => {
  const handleClick = (url) => 
  {
    window.location = url;
  }
  
  const renewalRows = renewalList && renewalList.length > 0
    && renewalList.map((renewal, i) => {
      var parts = renewal.expiration.split("-");
      var expiresDate = new Date(parts[0], parts[1] - 1, parts[2]);  // Avoid the UTC->local timezone translation issue with js

      return (
        <tr key={i} style={{cursor: "pointer"}} onClick={(e) => handleClick("/" + renewal.entityType + "/" + renewal.entityId)}>
          <td>{renewal.entityFormattedName}</td>
          <td style={{whiteSpace:"nowrap"}}>{expiresDate.toLocaleDateString("en-US")}</td>
          <td>{renewal.dataHubName}</td>
        </tr>
        )
  }, this);

  return (
    <Modal show={show} onHide={onClose} scrollable={true}>
    <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
      <Modal.Title>
        Data Hub Attestation{renewalList && renewalList.length > 1 ? "s" : ""} Due in Next 60 Days
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Table striped bordered hover size="sm"> 
        <thead>
          <tr>
            <td>Practice / Provider</td>
            <td>Attestation Date</td>
            <td>Data Hub</td>
          </tr>
        </thead>
        <tbody>
          {renewalRows} 
        </tbody>
      </Table>
    </Modal.Body>
    <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
      <Button onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
  )
}


const RenewalCount = ({practiceId}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const handleShow = () => 
  {
    if (data.length > 0)
      setShow(true);
  }
  const handleClose = () => setShow(false);

  useEffect(() => {
    authenticatedFetch({
      path: "provider/upcomingrenewalcount" + (practiceId != null && practiceId > 0 ? "/" + practiceId : ""),
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [practiceId])

  if (!isLoaded)
  {
    return (<>Loading...</>);
  }
  else if (error || data == null)
  {
    return (<>...</>);
  }
  else
  {
    return (
      <>
        <div className="flex-grow-1" style={{cursor: data && data.length > 0 ? 'pointer': 'default'}}  onClick={(e) => handleShow()}>
          <h3 className="mb-2">{!data ? 0 : data.length} Upcoming Attestation{!data || data.length === 0 || data.length > 1 ? "s" : ""}</h3>
          { data && data.length > 0 ?
          <>
            <p className="mb-2">Data hub attestations must be completed to remain current</p>
            <div className="mb-0">
              <span className="text-muted" style={{fontSize:"0.9em"}}>Due in </span>
                <Badge bg="" className="badge-soft-danger me-2">
                  &lt; 60 days
                </Badge>
            </div>
            </> 
            : <><p className="mb-2">No upcoming data hub attestations!</p></>
          }
        </div>
        <div className="d-inline-block ms-3">
          <div className="">
          { data && data.length > 0 ?
              <Clock className="align-middle text-danger" />
            : <Clock className="align-middle" style={{color: '#3AAFA9'}}/>
            }
          </div>
        </div>
        <RenewalModal show={show} onClose={handleClose} renewalList={data}/>
      </>
    )
  }
}

export default RenewalCount;